import EnvironmentSettings from "../../Models/EnvironmentSettings";
import UsersApi from "../UsersApi";

class SessionsApi {
  constructor() {
    EnvironmentSettings.Environment === "dev"
      ? (this.baseUrl = EnvironmentSettings.LocalUrl)
      : (this.baseUrl = EnvironmentSettings.LiveUrl);
    //console.log("baseUrl: ", this.baseUrl);
  }

  GetTenantsUrl = "Admin/tenants";

  async GetTenants(req) {
    const res = await fetch(this.baseUrl + this.GetTenantsUrl, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${UsersApi.GetToken()}`,
      },
    });

    const data = await res.json();
    console.log(data);
    return data;
  }
}

export default new SessionsApi();
